import React, { useEffect, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise/styles/ag-theme-alpine.css";
import "ag-grid-enterprise/styles/ag-grid.css";
import './App.css';
import { Button } from "antd";
import { Modal } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { API_ENDPOINT_CHECK_YOUR_EXEMPTED_DATA ,API_ENDPOINT_DELETE_EXEMPTED_DATA} from "../vendorfollowup.constants";

const Exemption = () => {
  const [vendors, setVendors] = useState([]);
  const [gridApi, setGridApi] = useState(null)

  const columns = [
    { headerName: "GSTIN", field: "gstin" },
    { headerName: "Vendor Name", field: "trade_legal_name" },
    {
      headerName: "Exempted By", field: "user_added", filter: "agSetColumnFilter", // Use AG Grid's set filter
      filterParams: {
        values: ["Manually Exempted", "Government Exempted"], // Dropdown filter options
        suppressMiniFilter: false, // Hides text search input
        applyMiniFilterWhileTyping: true, // Enables filtering while typing
      },
    },
    {
      headerName: "Action",
      field: "action",
      valueGetter: (params) => {
        return params.data.user_added === "Manually Exempted" ? "Remove" : "";
      },

      cellRenderer: (params) => {
        // Render the button only if the value is 'Remove'
        if (params.value === "Remove") {
          return (
            <button
              className="remove-button"
              onClick={() => {
                Modal.confirm({
                  title: "Confirm Removal",
                  content: "Are you sure you want to remove this exempted vendor?",
                  icon: <ExclamationCircleOutlined style={{ color: "#0A8394" }} />, // Custom icon color
                  okText: "Yes",
                  cancelText: "No",
                  okButtonProps: {
                    style: { backgroundColor: "#0A8394", color: "white", border: "none" },
                  },
                  cancelButtonProps: {
                    style: { backgroundColor: "white", color: "#0A8394", border: "1px solid #0A8394" }, // No button styles
                  },
                  onOk: () => handleRemoveClick(params.data.gstin), // Calls function on confirmation
                });
              }}
            >
              {params.value}
            </button>
          );
        }
        return null; 
      }
    }



  ];

  const currentWorkspace = localStorage.getItem('currentWorkspace');


  const getServerSideDatasource = () => {
    return {
      getRows: async (gridParams) => {
        console.log("Params:", gridParams);
        console.log("Grid request:", gridParams.request);
        try {
          const requestBody = {
            ...gridParams.request,
            database: "gstservice",
            table: "gst-exempted-data",
            workspaceid: currentWorkspace,
          };
          console.log("Column Definitions:", columns);
          console.log("[Datasource] - rows requested by grid: ", gridParams.request);
          const response = await fetch(API_ENDPOINT_CHECK_YOUR_EXEMPTED_DATA, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(requestBody),
          });
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          const data = await response.json();
          console.log("Data fetched:", data);
          // Assuming that the backend response returns data in the correct format
          if (data && Array.isArray(data?.data.rows)) {
            console.log("Data fetched new:", data.rows);


            gridParams.success({
              rowData: data.data.rows,
              rowCount: data.lastRow
            });
          } else {
            gridParams.fail();
          }
        } catch (error) {
          console.error("Error fetching server-side data:", error);
          gridParams.fail();
        }
      },
    };
  };

  const onGridReady = (params) => {
    setGridApi(params.api)
    const datasource = getServerSideDatasource();
    params.api.setGridOption("serverSideDatasource", datasource);
  };



  // Remove vendor via API
  const removeVendor = async (gstin) => {
    try {
      const response = await fetch(API_ENDPOINT_DELETE_EXEMPTED_DATA, {
        // const response = await fetch('http://localhost:5000/delete-exempted-data', {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ gstin }),
      });
      const result = await response.json();

      if (result.status === 'success') {
        // Update the list after deletion
        setVendors((prevVendors) =>
          prevVendors.filter((vendor) => vendor.gstin !== gstin)
        );
        gridApi.refreshServerSide();

      } else {
        console.error(result.message);
      }
    } catch (error) {
      console.error('Error removing vendor:', error);
    }
  };

  // Show confirmation popup
  const handleRemoveClick = (gstin) => {
    console.log("Inside handleRemoveClick");
      removeVendor(gstin);
  };


  const defaultColDef = {
    filter: true,
    floatingFilter: true,
    sortable: true,
    resizable: true,
    enableRowGroup: true,
    floatingFilter: true,
    flex: 1,
    filter: 'agTextColumnFilter',
  };

  const gridOptions = {

    animateRows: true,
    sideBar: {
      toolPanels: [
        {
          id: "columns",
          labelDefault: "Columns",
          labelKey: "columns",
          iconKey: "columns",
          toolPanel: "agColumnsToolPanel",
          minWidth: 225,
          maxWidth: 225,
          width: 225,
        },
        {
          id: "filters",
          labelDefault: "Filters",
          labelKey: "filters",
          iconKey: "filter",
          toolPanel: "agFiltersToolPanel",
          minWidth: 180,
          maxWidth: 400,
          width: 250,
        },

      ],
      position: "right",
    },

    icons: {
      pdfIcon: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M10.377 11.2188L10.3828 11.1914C10.4961 10.7246 10.6387 10.1426 10.5273 9.61523C10.4531 9.19922 10.1465 9.03711 9.88477 9.02539C9.57617 9.01172 9.30078 9.1875 9.23242 9.44336C9.10352 9.91211 9.21875 10.5527 9.42969 11.3691C9.16406 12.002 8.74023 12.9219 8.42969 13.4688C7.85156 13.7676 7.07617 14.2285 6.96094 14.8105C6.9375 14.918 6.96484 15.0547 7.0293 15.1777C7.10156 15.3145 7.2168 15.4199 7.35156 15.4707C7.41016 15.4922 7.48047 15.5098 7.5625 15.5098C7.90625 15.5098 8.46289 15.2324 9.20508 13.959C9.31836 13.9219 9.43555 13.8828 9.54883 13.8438C10.0801 13.6641 10.6309 13.4766 11.1289 13.3926C11.6797 13.6875 12.3066 13.877 12.7324 13.877C13.1543 13.877 13.3203 13.627 13.3828 13.4766C13.4922 13.2129 13.4395 12.8809 13.2617 12.7031C13.0039 12.4492 12.377 12.3828 11.4004 12.5039C10.9199 12.2109 10.6055 11.8125 10.377 11.2188ZM8.23438 14.1855C7.96289 14.5801 7.75781 14.7773 7.64648 14.8633C7.77734 14.623 8.0332 14.3691 8.23438 14.1855ZM9.94531 9.58594C10.0469 9.75977 10.0332 10.2852 9.95508 10.5508C9.85938 10.1621 9.8457 9.61133 9.90234 9.54688C9.91797 9.54883 9.93164 9.56055 9.94531 9.58594ZM9.91406 11.9395C10.123 12.3008 10.3867 12.6113 10.6777 12.8418C10.2559 12.9375 9.87109 13.0957 9.52734 13.2363C9.44531 13.2695 9.36523 13.3027 9.28711 13.334C9.54688 12.8633 9.76367 12.3301 9.91406 11.9395ZM12.9531 13.2188C12.9551 13.2227 12.957 13.2285 12.9453 13.2363H12.9414L12.9375 13.2422C12.9219 13.252 12.7617 13.3457 12.0723 13.0742C12.8652 13.0371 12.9512 13.2168 12.9531 13.2188ZM16.6914 5.63672L12.4883 1.43359C12.3711 1.31641 12.2129 1.25 12.0469 1.25H3.75C3.4043 1.25 3.125 1.5293 3.125 1.875V18.125C3.125 18.4707 3.4043 18.75 3.75 18.75H16.25C16.5957 18.75 16.875 18.4707 16.875 18.125V6.08008C16.875 5.91406 16.8086 5.75391 16.6914 5.63672ZM15.4336 6.36719H11.7578V2.69141L15.4336 6.36719ZM15.4688 17.3438H4.53125V2.65625H10.4297V6.875C10.4297 7.09256 10.5161 7.30121 10.67 7.45505C10.8238 7.60889 11.0324 7.69531 11.25 7.69531H15.4688V17.3438Z" fill="black" fill-opacity="0.45"/>
          </svg>`,
    },
  };


  return (
    <>
      <div className="ag-theme-alpine" style={{ height: 750, width: '100%' }}>
        <AgGridReact
          columnDefs={columns}
          onGridReady={onGridReady}
          rowModelType="serverSide"
          paginationPageSize={100}
          cacheBlockSize={100}
          defaultColDef={defaultColDef}
          gridOptions={gridOptions}
          rowGroupPanelShow="always"
          rowSelection="multiple"
          enableSorting={true}
          enableFilter={true}
        />
      </div>
    </>
  );
};

export default Exemption;
